import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: 'input[ssnNumber]'
})
export class SsnFormatInputDirective {

  constructor(private _el: ElementRef) {
  }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initialValue = this._el.nativeElement.value;

    let val = initialValue.replace(/[^0-9]*/g, '').replace(/-/g, '').replace(/ /g, '');

    const len = val.length;

    if (len >= 4 && len <= 5) {
      val = `${val.substr(0, 3)}-${val.substr(3, 2)}`;
    } else if (len >= 6 && len <= 9) {
      val = `${val.substr(0, 3)}-${val.substr(3, 2)}-${val.substr(5, len)}`;
    } else if (len > 9) {
      val = 'Invalid SSN';
    }

    this._el.nativeElement.value = val;

    if (initialValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }

}
